import React from 'react';
import pt from 'prop-types';
import Icon from '../../components/ui/icon';
import Link from '../../components/ui/link';
import LogoKakao from '../../images/logo-kakao.svg';
import LogoNaver from '../../images/logo-naver.svg';
import * as styles from './styles.module.scss';

const SocialIcons = ({ socialLinks }) => {
  return socialLinks.map((social, index) =>
    social.icon === 'naver' ? (
      <Link link={social} key={index} className={styles.logo}>
        <LogoNaver />
      </Link>
    ) : social.icon === 'kakao' ? (
      <Link link={social} key={index} className={styles.logo}>
        <LogoKakao />
      </Link>
    ) : (
      <Link link={social} key={index}>
        <Icon name={social.icon} type="fab" />
      </Link>
    )
  );
};

SocialIcons.propTypes = {
  socialLinks: pt.array.isRequired,
};

export default SocialIcons;
